import { Graphics } from 'pixi.js';
import type { Enemy } from '../enemies';

// Draw a dashed red aim-line from boss/miniboss toward the player during phase-warn windows.
// Pure stateless render — caller owns the Graphics + the enemy list.
export function drawBossTelegraph(g: Graphics, enemies: Enemy[], px: number, py: number): void {
  g.clear();
  for (const en of enemies) {
    if (!en.alive) continue;
    if ((en.kind !== 'boss' && en.kind !== 'miniboss') || en.warnT <= 0) continue;
    const a = Math.atan2(py - en.y, px - en.x);
    const dist = Math.hypot(px - en.x, py - en.y);
    const segments = 12;
    for (let i = 0; i < segments; i++) {
      if (i % 2) continue;
      const t0 = i / segments, t1 = (i + 1) / segments;
      g.moveTo(en.x + Math.cos(a) * dist * t0, en.y + Math.sin(a) * dist * t0);
      g.lineTo(en.x + Math.cos(a) * dist * t1, en.y + Math.sin(a) * dist * t1);
    }
    g.stroke({ width: 2, color: 0xff2200, alpha: 0.7 * Math.min(1, en.warnT * 2) });
  }
}
